var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNewFacebookIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#595D5C",
  d: "m16.034 13.125.492-3.234h-3.129V7.78c0-.914.422-1.758 1.829-1.758h1.441V3.246S15.367 3 14.136 3c-2.567 0-4.254 1.582-4.254 4.395V9.89H6.999v3.234h2.883V21h3.515v-7.875z"
})));
export default SvgNewFacebookIcon;